import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_marca/titular';
import TitularList from './TitularList';


const ms2p = (state) => {
  return {
    ...state.titular_rm,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(TitularList);
